export function scrollToTop(): void {
  const main = document.getElementById('main-content')
  if (main) {
    main.scrollTo({ top: 0, behavior: 'smooth' })
    return
  }
  window.scrollTo({ top: 0, behavior: 'smooth' })
}
